/**
 * castToBoolean
 *
 * @param {any} The value to cast
 * @returns {Boolean} True if value === 'true' or value === true, otherwise false.
 */
module.exports = (value, defaultValue = false) => (
  value === undefined ? defaultValue : value === 'true' || value === true
);



// WEBPACK FOOTER //
// ./src/js/helpers/castToBoolean.js